export default "__VITE_ASSET__J2HEep3U__"